<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="innerValue"
              prepend-icon="mdi-calendar"
              v-on="on"
              :label="label"
              :readonly="$attrs.readonly"
              :error-messages="errors"
              autocomplete="off"
             
            ></v-text-field>
          </template>
          <v-date-picker
            ref="picker"
            v-model="year"
            no-title
            :locale="$i18n.locale"
            @click:year="saveYear"
            :max="new Date((new Date().getFullYear() + 10).toString()).toISOString().substr(0, 10)"
            min="1900-01-01"
          >
          </v-date-picker>
        </v-menu>
        {{ year}}
        {{innerValue}}
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: [Number, String],
    },
    label: String
  },
  data() {
    return {
      menu: false,
      innerValue: null,
      year: null
    }
  },
  methods: {
    saveYear(year) {
        this.innerValue = new Date(`${year}`).toISOString().substr(0, 4);
        // activePicker to type YEAR
        setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
        // Close the menu/datepicker
        this.menu = false;
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
        if(newVal.length >= 4) {
          this.year = new Date(`${newVal}`).toISOString().substr(0, 10);
          this.$emit("input", newVal);
        }

    },
    // Handles external model changes.
    value(newVal) {
      if(newVal.length >= 4) {
        this.year = new Date(`${newVal}`).toISOString().substr(0, 10);
        this.innerValue = newVal;
      }
    },
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style>
</style>